import styled from 'styled-components';

export const HowItWorksStyles = styled.section`
  body.dark & {
    --card-step-bg: #9e1fda;
  }

  --card-step-bg: #fff;
  margin: 32px 0;

  .how-it-works-title {
    margin-bottom: 20px;
  }
`;
